import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public showBackButton$ = new BehaviorSubject(false);
  public hideNav$ = new BehaviorSubject(false);
  private _navigationOpen$ = new BehaviorSubject(false);
  public navigationOpen$ = this._navigationOpen$.pipe(shareReplay({ bufferSize: 1, refCount: true }));

  constructor() {}

  public setShowBackButton(state: boolean): void {
    //console.log('NavigationService setShowBackButton state ', state);
    this.showBackButton$.next(state);
  }

  public setHideNav(state: boolean): void {
    //console.log('NavigationService setTopBackButton state ', state);
    this.hideNav$.next(state);
  }

  public setNavigationOpen(state: boolean): void {
    //console.log('NavigationService setTopBackButton state ', state);
    this._navigationOpen$.next(state);
  }
}
